export default __webpack_public_path__ + "img/6a33e0eeb71df6197c9716058833a9bc.svg";